import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { RiHome2Line } from "react-icons/ri"

const TagsIndex = ({ data }) => {
const siteUrl = "https://static.wpgate.ml"

return (
  <Layout>
    <SEO
      title={`タグリスト`}
      description={`タグ一覧ページ`}
    />
    <h1 className="taxonomy-header">タグリスト</h1>
  <div>
    <ul className="tags-list">
      {data.allWpTag.edges.map(post => (
        <li key={post.node.id}>
        <Link to={`/tag/${post.node.name}`} >
          {post.node.name} <span>{post.node.count}</span>
        </Link>
        </li>
      ))}
    </ul>
    <div className="back-to-home">
          <Link to="/"><RiHome2Line />サイトトップへ</Link>
    </div>
  </div>

  <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "name": "パンくず🍞リスト",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "item": {
                  "@id": "${siteUrl + "/"}",
                  "name": "Home",
                  "@type": "Thing"
                }
              },
              {
                "@type": "ListItem",
                "position": 2,
                "item": {
                  "@id": "${siteUrl + "/tag/"}",
                  "name": "${"タグ一覧ページ"}",
                  "@type": "Thing"
                }
              }
            ]
          }
        `}
      </script>
  </Layout>
)}

export default TagsIndex

export const query = graphql`
  query {
    allWpTag(filter: {count: {gt: 0}}) {
      edges {
        node {
          id
          slug
          name
          count
        }
      }
    }
  }
`